var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.949219,
    width: 44.4138,
    height: 44.4138,
    rx: 7.4023,
    fill: "#212224"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85156 11.2031H34.5266",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85156 26.0078H34.5266",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2529 17.9867C17.2529 16.9456 17.15 15.7439 18.1782 15.1503C18.6076 14.9023 19.1841 14.9023 20.3372 14.9023H24.0385C25.1915 14.9023 25.7681 14.9023 26.1975 15.1503C27.2258 15.7439 27.1229 16.9456 27.1229 17.9867C27.1229 19.0279 27.2258 20.2295 26.1975 20.8232C25.7681 21.0711 25.1915 21.0711 24.0385 21.0711H20.3372C19.1841 21.0711 18.6076 21.0711 18.1782 20.8232C17.15 20.2295 17.2529 19.0279 17.2529 17.9867Z",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5575 32.7914C13.5575 31.7502 13.4547 30.5486 14.4829 29.955C14.9123 29.707 15.4888 29.707 16.6419 29.707H27.7457C28.8987 29.707 29.4753 29.707 29.9047 29.955C30.9329 30.5486 30.83 31.7502 30.83 32.7914C30.83 33.8326 30.9329 35.0342 29.9047 35.6278C29.4753 35.8758 28.8987 35.8758 27.7457 35.8758H16.6419C15.4888 35.8758 14.9123 35.8758 14.4829 35.6278C13.4547 35.0342 13.5575 33.8326 13.5575 32.7914Z",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreates);
export default __webpack_public_path__ + "static/media/creates.44e249a19e36a727549008a625fb0200.svg";
export { ForwardRef as ReactComponent };